var LoaderService = function ($rootScope) {

    var self = this;

    self.numPendingLoad = 0;

    /**
     * Shows the global loader
     */
    self.showLoader = function(){
        self.numPendingLoad++;
        $rootScope.isLoading = true;
    };

    /**
     * Hides the global loader
     */
    self.hideLoader = function() {
        self.numPendingLoad--;
        if (self.numPendingLoad <= 0) {
            $rootScope.isLoading = false;
            self.numPendingLoad = 0;
        }
    };

};

angular.module('dashboard')
    .service('LoaderService', ['$rootScope', LoaderService]);